<div
  [ngClass]="{ 'container-fluid h-200 mt-2': !fullHeight }"
  class="full-width"
  #scrollableContainer
  id="scrollableContainer"
  cdkScrollable
  (scroll)="updateViewportBreadcrumb()"
>
  <div class="viewport-breadcrumb" *ngIf="viewportBreadcrumb">
    <button
      type="button"
      class="breadcrumb-part breadcrumb-link"
      (click)="scrollToBreadcrumbSection()"
    >
      {{ viewportBreadcrumb.sectionLabel }}
    </button>
    <span class="breadcrumb-separator">&gt;</span>
    <button
      type="button"
      class="breadcrumb-part breadcrumb-link"
      (click)="scrollToBreadcrumbStep()"
    >
      {{ viewportBreadcrumb.stepLabel }}
    </button>
    <span class="breadcrumb-separator">&gt;</span>
    <span class="breadcrumb-part task">{{ viewportBreadcrumb.taskLabel }}</span>
  </div>
  <mat-accordion multi *ngIf="visibleSections.length" id="sections">
    <ng-container *ngFor="let section of visibleSections; let sectionIndex = index; trackBy: trackBySection">
      <div class="row no-gutters">
        <div class="full-width d-flex">
          <checklist-section
            class="full-width"
            [currentChecklist]="currentChecklist"
            [disabled]="disabled"
            [section]="section"
            [displayNumber]="sectionIndex + 1"
            [precheck]="precheck ?? false"
            (checkShared)="checkSharedComponents($event)"
            (taskChanged)="evaluateTaskConditions($event)"
            (viewportChanged)="refreshViewportBreadcrumbAfterLayout()"
          ></checklist-section>
        </div>
      </div>
    </ng-container>
    <div class="row mt-3 pb-3">
      <div class="col mx-3">
        <comments-and-attachments
          [currentDocument]="currentChecklist"
          [FormNumber]="currentChecklist?.serialNo"
          [disabled]="disabled"
          headerClass="h5"
        >
        </comments-and-attachments>
      </div>
    </div>
  </mat-accordion>
</div>
